<template>
  <div class="leaderboard">
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <div>
      <!-- Table starts here -->
      <table align="center">
        <thead>
          <tr>
            <th>User</th>
            <th style="cursor:pointer;" @click="orderBy('balance')">Swiftbucks</th>
            <th style="cursor:pointer;" @click="orderBy('watchTime')">Watch Time (minutes)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="leader in currentLeaders" v-bind:key="leader.user_id.toString()">
            <td data-title="User" class="user-cell">
              <User :user_id="leader.user_id"></User>
            </td>
            <td data-title="Swiftbucks">{{formatCurrency(leader.total)}}</td>
            <td data-title="WatchTime">{{formatCurrency(leader.minutes)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'bets',
  async created () {
    this.$store.dispatch('fetchBalanceLeaderboard')
    this.$store.dispatch('fetchWatchTimeLeaderboard')
  },
  data () {
    return {
      title_img: 'leaderboard-title.svg',
      order: 'balance'
    }
  },
  computed: Object.assign(mapState([
    // map this.count to store.state.count
    'watchTimeLeaderboard',
    'balanceLeaderboard'
  ]), {
    currentLeaders () {
      return this.order === 'balance' ? this.balanceLeaderboard : this.watchTimeLeaderboard
    }
  }),
  methods: {
    orderBy (ob) {
      this.order = ob
    }
  }
}
</script>

<style scoped>
table {
  width: 90%;
  border: 2px #b62626 solid;
  border-radius: 3px;
  border-collapse: separate;
  border-spacing: 0px;
}
tbody tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.3);
}
tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.2);
}
table tr {
  height: 40px;
  transition: background-color 0.2s;
}
tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
thead {
  background-color: #b62626;
  font-weight: bold;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Leaderboard.vue